<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.courseWhitelistDeletedList.push"
    :is-show-search-input="true"
    search-placeholder="输入名称进行搜索"
  >
    <v-column-time value="删除时间" field="del_time"/>
    <el-table-column label="白名单 ID" width="300" prop="id"/>
    <el-table-column label="白名单名称" width="300" prop="course_whitelist_name"/>
    <el-table-column label="白名单人数" width="300" prop="student_count"/>
    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.courseWhitelistManage.to(row.id)" name="管理"/>
        <v-list-button
          name="恢复"
          icon="restore"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="本白名单对应的课程将恢复预约限制，确定要恢复此白名单吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`course-whitelist-deleted-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.del_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>白名单 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>白名单名称</span>
              <span>{{ v.course_whitelist_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>白名单人数</span>
              <span>{{ v.student_count }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.courseWhitelistManage.to(v.id)" name="管理"/>
              <v-list-button
                name="恢复"
                icon="restore"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="本白名单对应的课程将恢复预约限制，确定要恢复此白名单吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { getLegalQueryList } from '@/utils/formats';
  import { index, restore } from '@/api/course-whitelist';

  export default {
    name: RouteConfig.courseWhitelistDeletedList.name,
    data: () => ({
      RouteConfig,
      isLoading: false,
      isDeleting: {},
      count: 0,
      list: [],
      queryList: {
        keyword: '',
        store_id: '',
        is_asc: 0,
        page: 1,
        size: 10,
      },
    }),
    watch: {
      '$route'(to) {
        this.load(to);
      },
    },
    beforeMount() {
      this.load();
    },
    methods: {
      async load(route = this.$route, next) {
        const { queryList } = this;
        getLegalQueryList(queryList, route.query);

        const params = { ...queryList };
        params.is_del = 1;

        this.isLoading = true;
        const { isError, data } = await index(params);
        this.isLoading = false;
        if (isError) return;

        this.count = data.count;
        this.list = data.list;
        if (next) next();
      },
      async handleDelete({ id, update_time }) {
        if (!id) return this.$message.warning('缺少白名单 ID，无法恢复！');
        if (this.isDeleting[id]) return;

        this.$set(this.isDeleting, id, true);
        const { isError } = await restore(id, { update_time });
        this.$set(this.isDeleting, id, false);

        if (!isError) this.load();
      },
    },
  };
</script>
